import { Middleware } from '@nuxt/types';

import WeatherService from '@root/modules/weather/services/Weather.service';

const weather: Middleware = async (context) => {
  const { route, store } = context;

  if (process.client) {
    return;
  }

  if (route.name === 'article' || route.name === 'articleComments') {
    return;
  }

  const weatherService = new WeatherService();
  const data = await weatherService.fetch({ hourlyTime: 0, dailyTime: 0, placeId: 'ChIJ9QhkXPuT3UYRQNzpcIzRAAQ', ttl: 3600 });

  if (data) {
    store.commit('navigation/setWeather', data);
  }
};

export default weather;
